import {Component, EventEmitter, Output} from '@angular/core';
import { SocialUser } from '@abacritt/angularx-social-login';
import { GoogleAuthenticationService } from 'src/app/core/login/google-authentication.service';
import { OauthService } from 'src/app/core/oauth/oauth.service';
import {SidenavService} from "../../core/sidenav/sidenav.service";
import {NotificationNegos} from "../../models/notification";
import {NotificationService} from "../../core/notification/notification.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  standalone: false,
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {

  @Output()
  changeMenuOption = new EventEmitter<boolean>();

  user: SocialUser;
  roles: string;
  notifications: NotificationNegos[];
  countNotification: number = 0;
  refreshNotificationInterval: any;

  constructor(private sidenavService: SidenavService,
    private googleAuthenticationService:GoogleAuthenticationService,
    private _oauthService: OauthService,
    private notificationService: NotificationService,
    private route: Router) {
  }

  toggleSideBar(){
    this.sidenavService.toggle();
  }

  ngOnInit(): void {

    this.user = this.googleAuthenticationService.getSocialUser;

    this._oauthService.aoutUser().subscribe({
      next: (roles) => {
        this.roles = roles?.roles?.[0] ?? '';
      },
      error: () => {
        this.roles = '';
      }
    });

    //Inicializamos las notificaciones
    this.getNotification();
    //Agregamos el timmer
    this.refreshNotification();
  }

  getNotification(){
    const email = this.user?.email?.trim();
    if (!email) {
      this.countNotification = 0;
      this.notifications = [];
      return;
    }
    this.notificationService.getNotification(email).subscribe({
      next: (notifications: NotificationNegos[]) => {
        this.countNotification = notifications.length;
        this.notifications = notifications;
      },
      error: () => {
        this.countNotification = 0;
        this.notifications = [];
      }
    });
  }

  /*
  markRead( idProceso: number ){
    this.notificationService.putNotificationMarkRead( idProceso ).subscribe( () => {
      //Cortamos el intervalo
      clearInterval(this.refreshNotificationInterval);
      //Actualizamos las notificaciones
      this.getNotification();
      //Activamos de nuevo el timmer
      this.refreshNotification();

      this.changeMenuOption.emit(true);
      this.route.navigate(['/pages/status'],
        {
          queryParams:{ idProceso }
        })
    })
  }*/

  onlyMarkRead( idProceso: number ){
    this.notificationService.putNotificationMarkRead( idProceso ).subscribe( () => {
      //Cortamos el intervalo
      clearInterval(this.refreshNotificationInterval);
      //Actualizamos las notificaciones
      this.getNotification();
      //Activamos de nuevo el timmer
      this.refreshNotification();

    })
  }

  onlySee( idProceso: number ){
    this.changeMenuOption.emit(true);
    this.route.navigate(['/pages/status'],
      {
        queryParams:{ idProceso }
      })
  }

  refreshNotification(){
    this.refreshNotificationInterval = setInterval( () => {
      this.getNotification();
    }, 20000);
  }

}
